var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"back-button",on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('fa-icon',{attrs:{"icon":['far', 'arrow-left']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }